module.exports = __webpack_public_path__ + "static/media/m2.19905fd1.jpg";